import {
  InterfaceEventsEnum,
  trackInterfaceEvent,
} from '../../../../libs/shared/core/src/services/tracking/tracking';
import {CardModel} from '../../../models/api/cardModel';
import {
  AccountDetailsEventTypesEnum,
  AccountDetailsTrackingEvent,
} from '../../accounts/tracking/accountDetailsTrackingHelpers';
import {
  buildAccountDetailsEditTrackingPayload,
  buildContactDetailsHoverPayload,
  buildOpenConversationPayload,
  ContactDetailsTrackingDisplayContextOptionsEnum,
} from '../contactDetailsTrackingHelpers';

/*
 * Helpers.
 */

export function contactDetailsAccountDetailsTrackingHandler(
  card: CardModel | undefined,
  event: AccountDetailsTrackingEvent,
  context: ContactDetailsTrackingDisplayContextOptionsEnum = ContactDetailsTrackingDisplayContextOptionsEnum.ACCOUNT,
) {
  switch (event.type) {
    case AccountDetailsEventTypesEnum.HOVER: {
      if (!card) {
        return;
      }
      trackInterfaceEvent(
        InterfaceEventsEnum.P4_CONTACT_DETAILS_HOVER,
        buildContactDetailsHoverPayload(card, event.section, context),
      );
      break;
    }
    case AccountDetailsEventTypesEnum.OPEN_CONVERSATION: {
      if (!card) {
        return;
      }
      trackInterfaceEvent(
        InterfaceEventsEnum.P4_CONTACT_DETAILS_OPEN_CONVERSATION,
        buildOpenConversationPayload(card, event.section, context),
      );
      break;
    }
    case AccountDetailsEventTypesEnum.EDIT: {
      if (!card) {
        return;
      }
      const payload = buildAccountDetailsEditTrackingPayload(card, event.action, event.attribute);
      if (!payload) {
        return;
      }
      trackInterfaceEvent(InterfaceEventsEnum.P4_CONTACT_DETAILS_EDIT, payload);
      break;
    }
    default:
    // Do not track anything
  }
}
